import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import NavBar from '../NavBar';
import Svg from '../Svg';
import Icon from '../Icon';
import IconButton from '../IconButton';
import Dropdown from '../Dropdown';
import HeaderPatientInfo from '../HeaderPatientInfo';
import { PatientInfoVisibility } from '../../types/PatientInfoVisibility';
import classnames from 'classnames';
import Notification from '../Notification';

function Header({
  // data,
  children,
  menuOptions,
  isReturnEnabled,
  onClickReturnButton,
  isSticky,
  WhiteLabeling,
  showPatientInfo = PatientInfoVisibility.VISIBLE_COLLAPSED,
  servicesManager,
  Secondary,
  appConfig,
  ...props
}: withAppTypes): ReactNode {
  const { t } = useTranslation('Header');
  const [isLightTheme, setIsLightTheme] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isOpenLayout, setIsOpenLayout] = useState(localStorage.getItem('isOpenLayout'));
  const [showNotification, setShowNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isButtonDisabled, setButtonIsDisabled] = useState(false);
  const [isElectronAppInstalled, setIsElectronAppInstalled] = useState({
    protocol: 'artemviewer',
    registered: false,
  });
  // -------------------------NEW FOR AVS OR 3D INTALLED ORT NOT
  const [Avs3dInstalled, setAvs3dInstalled] = useState({
    inobitec: 'not installed',
    vnc: 'not installed',
  });
  const [isInobitecAppInstalled, setIsInobitecAppInstalled] = useState(false);
  const isOpen = localStorage.getItem('isOpenLayout');

  const handleApiError = message => {
    setErrorMessage(message);
    setShowNotification(true);

    // Automatically hide the notification after 3 seconds
    setTimeout(() => {
      setShowNotification(false);
    }, 3000);
  };

  useEffect(() => {
    fetch('http://127.0.0.1:5001/status/installed') //check_aviewr
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('datadata', data);
        setAvs3dInstalled(data);
        setIsElectronAppInstalled(data);
      })
      .catch(error => {
        setIsElectronAppInstalled({ protocol: 'artemviewer', registered: false });
        console.error('Fetch error:', error);
      });

    // is-inobitec-installed

    // fetch('http://127.0.0.1:5001/check-protocol/inobitec')
    //   .then(response => {
    //     if (!response.ok) {
    //       throw new Error('Network response was not ok');
    //     }
    //     return response.json();
    //   })
    //   .then(data => {
    //     console.log('is-inobitec-installed', data.registered);
    //     setIsInobitecAppInstalled(data.registered);
    //   })
    //   .catch(error => {
    //     setIsInobitecAppInstalled(false);
    //     console.error('Fetch error:', error);
    //   });
  }, []);

  // useEffect(() => {
  //   handleApiError('Test Test  11');
  // }, []);
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1424px)'); // Adjust the breakpoint as needed
    const handleMediaChange = () => {
      setIsSmallScreen(mediaQuery.matches);
      setIsOpenLayout(localStorage.getItem('isOpenLayout'));
    };

    handleMediaChange();

    mediaQuery.addEventListener('change', handleMediaChange);

    return () => mediaQuery.removeEventListener('change', handleMediaChange);
  }, [localStorage.getItem('isOpenLayout')]);
  // TODO: this should be passed in as a prop instead and the react-router-dom
  // dependency should be dropped
  const onClickReturn = () => {
    // if (isReturnEnabled && onClickReturnButton) {
    //   onClickReturnButton();
    // }
  };
  const onClickTab = themeName => {
    setIsLightTheme(themeName);
    localStorage.setItem('theme', themeName);
  };

  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const token = params.get('tokens');
  const studyInstanceUIDsNew = url.searchParams.get('StudyInstanceUIDs');

  const StudyInstanceUIDs = studyInstanceUIDsNew;
  const studyInstanceUID = localStorage.getItem('StudyInstanceUID'); //params.get('StudyInstanceUIDs');
  const seriesInstanceUIDs = localStorage.getItem('SeriesInstanceUID'); //params.get('StudyInstanceUIDs');
  const patient_id =
    servicesManager?.services?.displaySetService?.getActiveDisplaySets()[0]?.instances[0][
      'PatientID'
    ];

  const checkServerResponsing = apiUrl => {
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => {
        if (!response.ok) {
          return response;
        }
        return response.json(); // Parse JSON response
      })
      .then(responseData => {
        return responseData;
      })
      .catch(error => {
        return error;
      });
  };
  function getCookie(name) {
    const cookie = {};
    document.cookie.split(';').forEach(function (el) {
      const split = el.split('=');
      cookie[split[0].trim()] = split.slice(1).join('=');
    });
    return cookie[name];
  }

  const artemLoginHandler = async (showError, retryCount, maxRetries) => {
    let baseUrl;
    const hostname = window.location.hostname;
    if (hostname.includes('dev')) {
      baseUrl = 'https://dev.bmchealth.in';
    } else if (hostname.includes('qa')) {
      baseUrl = 'https://qa.bmchealth.in';
    } else if (hostname.includes('uat')) {
      baseUrl = 'https://uat.bmchealth.in';
    } else {
      // Default case or production
      baseUrl = 'https://dev.bmchealth.in';
    }
    // ----------------------------------- Artem Login -------------------------------------
    if (!getCookie('avs_vm_request_id') || !getCookie('ohif_application_user_token')) {
      const artemLoginUrl = `${baseUrl}/api/v1/radiology/login/artem-login`;
      const url = artemLoginUrl;
      const weburl = new URL(window.location.href);
      const tokenweb = weburl.searchParams.get('tokens');
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${tokenweb}`,
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          if (response.status === 401) {
            // need to get new token fron refesh token
            clearCookies();
            return false;
          }
          const data = await response.json();
          showError = true;
          handleApiError(data?.responseMessage);
          return false;
        }

        const data = await response.json();

        if (!showError) {
          document.cookie =
            'avs_vm_request_id=' +
            data.responseObject['avs_vm_request_id'] +
            '; path=/; secure; samesite=strict';
          document.cookie =
            'requested_user_email=' +
            data.responseObject['requested_user_email'] +
            '; path=/; secure; samesite=strict';
          document.cookie =
            'ohif_application_user_token=' +
            data.responseObject['ohif_application_user_token'] +
            '; path=/; secure; samesite=strict';
        }
        return true;
      } catch (error) {
        setTimeout(() => {
          setButtonIsDisabled(false);
        }, 3000);
        showError = true;
        console.log(error);
        if (error.status === 504) {
          handleApiError('Unable to connect to Radiology Services');
        } else {
          handleApiError('Unexpected error from Radiology Services');
        }
        return false;
      }
    }
  };

  const createStudyHandler = async (retryCount, maxRetries) => {
    const createUrl = 'https://artem.bmchealth.in:8002/api/avs/study/create/';
    const CREATE_BODY = {
      avs_vm_request_id: getCookie('avs_vm_request_id'),
      dicom_study_uid: StudyInstanceUIDs,
      dicom_series_uid: seriesInstanceUIDs,
    };

    try {
      handleApiError('Creating Dicom image...');
      const responeToCreate = await fetch(createUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Artem-Token ${getCookie('ohif_application_user_token')}`,
        },
        body: JSON.stringify(CREATE_BODY),
      });
      // Handle 404 or 409 errors in the create API
      if (responeToCreate.status === 404) {
        handleApiError(
          'Your AVS Allocation access has been revoked. Please wait while we reassign a new AVS.'
        );
        clearCookies();
        openAvsHandler();
        return false;
      } else if (responeToCreate.status === 400) {
        handleApiError('AVS credentials have expired. Transferring new credentials now.');
        clearCookies();
        openAvsHandler();
        return false;
      }

      if (!responeToCreate.ok) {
        handleApiError('Unexpected error from AVS Services');
        return false;
      }

      const createStudy = await responeToCreate.json();

      // requested_user_token
      if (!getCookie('requested_user_token')) {
        document.cookie =
          'requested_user_token=' +
          createStudy['requested_user_token'] +
          '; path=/; secure; samesite=strict';
      }
      handleApiError('Dicom image In progress...');
      return createStudy;
      //   const errorStatus =
    } catch (error) {
      handleApiError('Unexpected error from AVS Services');
      return false;
    }
  };

  const openAVSAppHandler = async createStudy => {
    try {
      const openAvs = await fetch('http://127.0.0.1:5001/connect', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          avs_vm_request_id: createStudy['avs_vm_request_id'],
          requested_user_token: createStudy['requested_user_token']
            ? createStudy['requested_user_token']
            : getCookie('requested_user_token'),
        }),
      });

      if (openAvs.ok) {
        handleApiError('Starting AVS Viewer');
      } else {
        handleApiError('Something went wrong from AVS Desktop Connector');
      }
    } catch (error) {
      handleApiError('AVS Desktop Connector is Unreachable');
    }
  };

  const openAvsHandler = async (retryCount = 0, maxRetries = 1) => {
    handleApiError('Authenticating....');
    const showError = false;
    if (isButtonDisabled) {
      return;
    }
    setButtonIsDisabled(true);

    const isLoggedinSuccessfully = await artemLoginHandler(showError, retryCount, maxRetries);
    // ----------------------------------------------------------------------------------
    // Create URL API call

    if (
      isLoggedinSuccessfully === true ||
      (getCookie('avs_vm_request_id') && getCookie('ohif_application_user_token'))
    ) {
      const createStudy = await createStudyHandler(retryCount, maxRetries);
      if (createStudy) {
        await openAVSAppHandler(createStudy);
      }
    }
    setButtonIsDisabled(false);
  };
  function clearCookies() {
    document.cookie =
      'avs_vm_request_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=strict';
    document.cookie =
      'requested_user_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=strict';
    document.cookie =
      'ohif_application_user_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=strict';
    document.cookie =
      'requested_user_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=strict';
    // requested_user_token
  }
  const open3dViewewr = () => {
    try {
      // const inobeticUrl = `inobitec://?pacs-aetitle=ARTEM&patient-id=${JSON.parse(localStorage.getItem('single_study'))[0]['00100020'].Value[0]}&series-uid=${seriesInstanceUIDs}&open-series-images`;

      handleApiError('3D Viewer is opening....');
      const inobeticUrl = `inobitec://?pacs-aetitle=ARTEM&patient-id=${patient_id}&series-uid=${seriesInstanceUIDs}&open-series-images`;

      // const inobeticUrl = `inobitec://?pacs-aetitle=ARTEM&patient-id=${JSON.parse(localStorage.getItem('single_study'))[0]['00100020'].Value[0]}&series-uid=${seriesInstanceUIDs}&open-series-images`;
      window.open(inobeticUrl, '_blank');
    } catch (error) {
      console.log('error', error);
      handleApiError(`Failed to Open 3d Viewer: ${error.message}`);
    }
  };

  // id, type, message, actions, onSubmit, onOutsideClick, onKeyPress
  return (
    <NavBar
      isSticky={isSticky}
      {...props}
    >
      {showNotification && (
        <Notification
          id="1"
          type="error"
          message={errorMessage}
          actions={[]}
        />
      )}
      <div className="relative h-[68px] items-center ">
        <div className="flex flex-grow-[4] items-center">
          <div className="absolute left-0 top-1/2 ml-2 mb-2 flex -translate-y-1/2 items-center">
            <div
              className={classNames(
                ' mr-3 inline-flex items-center',
                isReturnEnabled && 'cursor-pointer'
              )}
              style={{ cursor: 'inherit' }}
              onClick={onClickReturn}
              data-cy="return-to-work-list"
            >
              {/* {isReturnEnabled && (
                <Icon
                  name="chevron-left"
                  className="text-primary-active w-8"
                />
              )} */}
              <div className="ml-1">
                {WhiteLabeling?.createLogoComponentFn?.(React, props) || (
                  <>
                    {isSmallScreen ? (
                      <Svg name="artem-small-icon-new" />
                    ) : (
                      <Icon
                        className="w-15 h-12"
                        name="artem-color-icons"
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="absolute top-1/2 left-[250px]  h-8 -translate-y-1/2">{Secondary}</div>
          {children && (
            <div
              // className={`custom-scrollbar absolute left-1/2 top-1/2 max-h-screen max-w-full -translate-x-1/2 -translate-y-1/2 transform overflow-auto rounded-l-lg bg-white bg-opacity-30 sm:max-w-[90%] md:max-w-[76%] ${
              //   isOpen === 'true' && 'rounded-r-lg'
              //   }  ${isSmallScreen === true && isOpenLayout === 'true' && 'left-[30%]'}`}
              className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform rounded-lg bg-white bg-opacity-30"
            >
              <div className="flex items-center justify-center space-x-2">{children}</div>
            </div>
          )}
        </div>
        {/*   <div className="absolute right-0 top-1/2 flex -translate-y-1/2 select-none items-center">
          {showPatientInfo !== PatientInfoVisibility.DISABLED && (
            <HeaderPatientInfo
              servicesManager={servicesManager}
              appConfig={appConfig}
            />
          )}
          <div className="border-primary-dark mx-1.5 h-[25px] border-r"></div>
         <div className="flex-shrink-0">
            <Dropdown
              id="options"
              showDropdownIcon={false}
              list={menuOptions}
              alignment="right"
            >
              <IconButton
                id={'options-settings-icon'}
                variant="text"
                color="inherit"
                size="initial"
                className="text-primary-active hover:bg-primary-dark h-full w-full"
              >
                <Icon name="icon-settings" />
              </IconButton>
            </Dropdown>
          </div>
        </div>*/}
        {(Avs3dInstalled.inobitec === 'installed' || Avs3dInstalled.vnc === 'installed') && (
          <div className="flex flex-grow items-center justify-end gap-3">
            {token && params.size !== 0 && (
              <div className="absolute right-0 top-1/2 mr-2 flex -translate-y-1/2 cursor-pointer select-none items-center  rounded-lg bg-white bg-opacity-30 p-1 px-3">
                <div className="flex">
                  {Avs3dInstalled.inobitec === 'installed' && (
                    <button className="text-common-bright !text-common-bright hover:!text-primary-light mt-2 mb-2 flex inline-flex items-center justify-center rounded-md rounded p-1 text-center text-lg font-bold outline-none transition duration-300 ease-in-out hover:opacity-80 focus:opacity-80 focus:outline-none active:opacity-100">
                      <Icon
                        name="3D-Icon"
                        // className="text-common-bright !text-common-bright hover:!bg-primary-dark hover:!text-primary-light inline-flex h-5 w-4 items-center justify-center rounded-md border-white text-center text-lg font-bold outline-none transition duration-300 ease-in-out hover:opacity-80 hover:opacity-80 focus:opacity-80 focus:outline-none active:opacity-100"
                        onClick={() => open3dViewewr()}
                      />
                    </button>
                  )}
                </div>
                {Avs3dInstalled.vnc === 'installed' && Avs3dInstalled.inobitec === 'installed' && (
                  <div className="border-white-active mx-1 border-l py-3"></div>
                )}
                {Avs3dInstalled.vnc === 'installed' && (
                  <div
                    className="flex"
                    onClick={() => openAvsHandler(0)}
                  >
                    <button
                      disabled={isButtonDisabled}
                      className="text-common-bright !text-common-bright hover:!bg-primary-dark1 hover:!text-primary-light mt-2 mb-2 inline-flex items-center justify-center rounded-md rounded p-1 text-center text-lg font-bold outline-none transition duration-300 ease-in-out hover:opacity-80 focus:opacity-80 focus:outline-none active:opacity-100"
                    >
                      <Icon name="av-icon-inobitec" />
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </NavBar>
  );
}

Header.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  WhiteLabeling: PropTypes.object,
  showPatientInfo: PropTypes.string,
  servicesManager: PropTypes.object,
};

Header.defaultProps = {
  isReturnEnabled: true,
  isSticky: false,
};

export default Header;
